// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"113":"5d797e62","367":"1927c86c","890":"5c948591","910":"1ad56c19"}[chunkId] + ".chunk.css";
};